import { AxiosResponse } from 'axios';

import { loginApi } from '../../setup/setupApi';
import { SupplementaryField } from './types';

export const getSupplementaryFields = (projectId: string): Promise<SupplementaryField[]> =>
  loginApi.get(`/projects/${projectId}/field`).then((res) => res.data);

export const updateSupplementaryFields = (
  projectId: string,
  body: SupplementaryField[]
): Promise<boolean> =>
  loginApi
    .put<SupplementaryField[], AxiosResponse<boolean>>(`/projects/${projectId}/field`, body)
    .then((res) => res.data);

export const deleteSupplementaryFields = (projectId: string, fieldName: string): Promise<boolean> =>
  loginApi.delete(`/projects/${projectId}/field/${fieldName}`).then((res) => res.data);
